export const normalize = (s?: string) =>
  (s || "").toLowerCase().replace(/\./g, "").replace(/\s+/g, " ").trim();

export const parseSubInfo = (
  raw: any,
  isSub: boolean
): { dir: "IN" | "OUT"; minute: number } | null => {
  if (!raw || typeof raw !== "string") return null;
  const first = raw.split(";").filter(Boolean)[0];
  if (!first) return null;
  const [minStr] = first.split("|");
  const minute = Number(minStr);
  if (!Number.isFinite(minute)) return null;
  return { dir: isSub ? "IN" : "OUT", minute };
};

export const parseLup = (lupRaw?: string) => {
  const result = {
    home: { starting: [] as string[], subs: [] as string[] },
    away: { starting: [] as string[], subs: [] as string[] },
  };
  if (!lupRaw || typeof lupRaw !== "string") return result;

  const [homeRaw = "", awayRaw = ""] = lupRaw.split("||");

  const parseSide = (chunk: string) => {
    const [firstPart = "", rest = ""] = chunk.split("|Substitutes;");
    const endTrim = (s: string) => s.split("|")[0].trim();

    const starters = endTrim(firstPart)
      .split(";")
      .map((x) => x.trim())
      .filter(Boolean);

    const subs = endTrim(rest)
      .split(";")
      .map((x) => x.trim())
      .filter(Boolean);

    return { starters, subs };
  };

  const h = parseSide(homeRaw);
  const a = parseSide(awayRaw);

  result.home.starting = h.starters;
  result.home.subs = h.subs;
  result.away.starting = a.starters;
  result.away.subs = a.subs;

  return result;
};
